/**
 * Analytics sessions are stored under a path with no host (pagePerformances), so a URL owns the sessions
 * of its path only on the origin Analytics is taken to report: the URL-prefix Search Console property's.
 * A domain property (`sc-domain:`) names no origin, and then, like a workspace without Search Console,
 * the website's stands in. The rule: traffic-measurement.md, Input.
 */
const trafficOriginOf = (workspace) => {
    const property = workspace.searchConsoleSettings?.siteUrl;
    return new URL(property && !property.startsWith('sc-domain:') ? property : workspace.websiteUrl).origin;
};

/** The path the URL's traffic is stored under, or null when the URL is on another origin and has none. */
export const trafficPathOf = (uri, workspace) => {
    const url = new URL(uri);
    return url.origin === trafficOriginOf(workspace) ? url.pathname + url.search : null;
};
